import { useContext } from 'react';

import { ApiContext } from './providers/context';
import type { ApiRegistry } from './provider';

export function useApi(): ApiRegistry {
  const registry = useContext(ApiContext);
  if (!registry) {
    throw new Error('useApi must be used within ApiRegistryProvider');
  }
  return registry;
}
